import type { Observable as ObservableType } from 'rxjs/Observable';
import fetchJson$ from '@atlassian/jira-fetch/src/utils/as-json-stream.tsx';
import type { Response } from './types';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (baseUrl: string, boardId: number): ObservableType<Response> =>
	fetchJson$(`${baseUrl}/rest/greenhopper/1.0/rapid/charts/velocity.json?rapidViewId=${boardId}`);
